/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shopping_PartlyInputs */

const en_shopping_partly = /** @type {(inputs: Shopping_PartlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's left (partly bought)`)
};

const de_shopping_partly = /** @type {(inputs: Shopping_PartlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rest (teils gekauft)`)
};

/**
* | output |
* | --- |
* | "What's left (partly bought)" |
*
* @param {Shopping_PartlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_partly = /** @type {((inputs?: Shopping_PartlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_PartlyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_partly(inputs)
	return en_shopping_partly(inputs)
});